import cx from "classnames";
import React from "react";

import { Icon, IconSize } from "@gaming/xds-react-js";
import { Open } from "@gaming/xds-react-js-icons";

import { useProgramFillColorPicker } from "../../../helpers/useProgramColorPicker";
import * as styles from "./ExternalLinkIcon.module.css";

type ExternalLinkIconProps = Readonly<{
  ignoreProgramColor?: boolean;
}>;

export const ExternalLinkIcon = ({ ignoreProgramColor }: ExternalLinkIconProps) => {
  const fillColor = useProgramFillColorPicker();
  return (
    <Icon
      className={cx(styles.externalLinkIcon, !ignoreProgramColor ? fillColor : "")}
      icon={Open}
      iconSize={IconSize.Custom}
    />
  );
};
